import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F25022",
      d: "M9 0H0v9h9z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#00A4EF",
      d: "M9 10H0v9h9z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7FBA00",
      d: "M19 0h-9v9h9z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFB900",
      d: "M19 10h-9v9h9z"
    }, null, -1)
  ])))
}
export default { render: render }